<template>
  <b-modal
    v-model="modalShow"
    @hidden="$emit('hidden')"
    size="lg"
  >
    <template #modal-header="{ close }">
      <div class="d-flex align-items-center flex-fill">
        <h5 class="mb-0" v-if="record">Deduções - Registro #{{record.id}}</h5>

        <b-button class="ml-auto" size="sm" variant="link" @click="close()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </b-button>
      </div>
    </template>

    <template #default>
      <div class="row">
        <div class="mt-3 col-md-5">
          <b-form-group
            label="Dias a serem deduzidos até 16/12/1998:"
            label-for="days-1"
          />
        </div>
        <div class="mt-2 d-flex col-md-5">
          <b-form-input
            placeholder="Dias"
            id="days-1"
            type="number"
            min="0"
            :max="maxDeduction1"
            v-model="form.deduction1"
            :state="getValidationState('deduction1')"
            required
          />
          <div>
            <div class="input-group-text">dias</div>
          </div>
        </div>
        <div class="mt-1 col-md-12">
          <b-form-invalid-feedback :state="getValidationState('deduction1')" v-if="!getValidationState('deduction1')">
            Valor máximo permitido: {{ maxDeduction1 }} dias
          </b-form-invalid-feedback>
        </div>
      </div>
      <hr v-if="hasRegime || record.regimeType === 'RGPS'">
      <div v-if="hasRegime || record.regimeType === 'RGPS'" class="row">
        <div class="mt-3 col-md-5">
          <b-form-group
            :label="labelDeduction2"
            label-for="days-2"
          />
        </div>
        <div class="mt-2 d-flex col-md-5">
          <b-form-input
            placeholder="Dias"
            id="days-2"
            type="number"
            min="0"
            :max="maxDeduction2"
            v-model="form.deduction2"
            :state="getValidationState('deduction2')"
            required
          />
          <div>
            <div class="input-group-text">dias</div>
          </div>
        </div>
        <div class="mt-1 col-md-12">
          <b-form-invalid-feedback :state="getValidationState('deduction2')" v-if="!getValidationState('deduction2')">
            Valor máximo permitido: {{ maxDeduction2 }} dias
          </b-form-invalid-feedback>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="mt-3 col-md-5">
          <b-form-group
            :label="form.regimeDate && hasRegime && record.regimeType === 'RPPS' 
              ? `Dias a partir de ${form.regimeDate} até hoje:` 
              : !hasRegime && record.regimeType === 'RPPS' 
              ? 'De 17/12/1998 até hoje:'
              : 'Dias até hoje:'"
            label-for="days-3"
          />
        </div>
        <div class="mt-2 d-flex col-md-5">
          <b-form-input
            placeholder="Dias"
            id="days-3"
            type="number"
            min="0"
            :max="maxDeduction3"
            v-model="form.deduction3"
            :state="getValidationState('deduction3')"
            required
          />
          <div>
            <div class="input-group-text">dias</div>
          </div>
        </div>
        <div class="mt-1 col-md-12">
          <b-form-invalid-feedback :state="getValidationState('deduction3')" v-if="!getValidationState('deduction3')">
            Valor máximo permitido: {{ maxDeduction3 }} dias
          </b-form-invalid-feedback>
        </div>
      </div>
    </template>

    <template #modal-footer="{ cancel }">
      <b-button
        variant="primary"
        @click="save"
        :disabled="!isFormValid"
      >
        Aplicar
      </b-button>

      <b-button
        variant="outline-primary"
        @click="cancel()"
      >
        Cancelar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import axios from 'axios';
import InputDatePicker from '@/components/InputDatePicker.vue';
import moment from 'moment';

export default {
  name: 'ModalDeductionForm',

  components: {
    InputDatePicker,
  },

  props: {
    record: {
      type: Object,
    },
    regimeDate: {
      type: [String],
      required: false
    },
    hasRegime: {
      type: [Boolean],
      required: false
    },
    parentId: {
      type: String,
    },
  },

  data: () => ({
    isLoading: false,
    isSaving: false,
    modalShow: true,
    form: {
      deduction1: 0,
      deduction2: 0,
      deduction3: 0,
    },
  }),

  created() {
    if (this.record) {
      this.form = { ...this.record };
    }
    if (this.regimeDate) {
      const regimeDateFormatted = moment(this.regimeDate).format('DD/MM/YYYY');
      this.form.regimeDate = regimeDateFormatted;
    }
  },

  computed: {
    maxDeduction1() {
      if (moment(this.form.ingressDate).isAfter(moment("1998-12-16"))) return 0;

      let days = moment(this.form.egressDate).diff(moment(this.form.ingressDate), "days");

      if (moment(this.form.egressDate).isAfter(moment("1998-12-16"))) {
        const extraDays = moment(this.form.egressDate).diff(moment("1998-12-16"), "days");

        days = days - extraDays
      }

      return days;
    },

    maxDeduction2() {
      if (moment(this.form.ingressDate).isAfter(moment("2019-11-13"))) return 0;

      let days = moment(this.form.egressDate).diff(moment(this.form.ingressDate), "days");

      if (moment(this.form.egressDate).isAfter(moment("2019-11-13"))) {
        const extraDays = moment(this.form.egressDate).diff(moment("2019-11-13"), "days");

        days = days - extraDays;
      }

      return days;
    },

    maxDeduction3() {
      if (moment(this.form.egressDate).isBefore(moment("2019-11-14"))) return 0;

      let days = moment(this.form.egressDate).diff(moment(this.form.ingressDate), "days");

      if (moment(this.form.ingressDate).isBefore(moment("2019-11-14"))) {
        const extraDays = moment("2019-11-14").diff(moment(this.form.ingressDate), "days");

        days = days - extraDays;
      }

      return days;
    },

    labelDeduction2() {
      if (this.form.regimeDate && this.record.regimeType === 'RPPS') {
        return `Dias a serem deduzidos até ${
          moment(this.form.regimeDate, 'DD/MM/YYYY').subtract(1, 'day').format('DD/MM/YYYY')
        }:`;
      }
      return 'Dias a serem deduzidos até 13/11/2019:';
    },

    isFormValid() {
      return this.getValidationState('deduction1') && 
             this.getValidationState('deduction2') && 
             this.getValidationState('deduction3');
    },
  },

  methods: {
    getValidationState(field) {
      const value = this.form[field];
      const maxValue = this[`max${field.charAt(0).toUpperCase() + field.slice(1)}`];
      
      if (maxValue === -1) return true;
      
      if (value === null || value === undefined || value === '') return true;
      
      return parseInt(value) <= maxValue;
    },

    async save() {
      if (!this.isFormValid) {
        this.$toast.open({
          message: 'Por favor, corrija os valores que excedem o máximo permitido',
          type: 'error',
          position: 'top-right'
        });
        return;
      }

      this.isLoading = true;
      this.isSaving = true;

      try {
        await this.saveOrUpdate();

        this.$toast.open({
          message: 'Registro salvo com sucesso',
          type: 'success',
          position: 'top-right'
        });

        this.$emit('save');
        this.$emit('hidden');
      } catch (error) {
        this.$toast.open({
          message: 'Erro ao salvar',
          type: 'error',
          position: 'top-right'
        });
      } finally {
        this.isSaving = false;
        this.isLoading = false;
      }
    },

    saveOrUpdate() {
      const formData = {
        ...this.form,
        deduction1: this.form.deduction1 || 0,
        deduction2: this.form.deduction2 || 0,
        deduction3: this.form.deduction3 || 0,
      };

      const body = { workRecord: formData };

      if (this.form.id) {
        return axios.put(`/work-records/${this.form.id}`, body);
      } else {
        return axios.post('/work-records', body);
      }
    },
  }
}
</script>

<style scoped>
</style>
